import React from 'react'
import { Link } from "react-router-dom"
import './Header.css'

import logoImage from '../../images/logo.png'
import creditImage from '../../images/credit.png'
import appStoreBadge from '../../images/app_store_badge.png'

const Header = () => {
    return (
        <React.Fragment>
            <header className="bg-image">
                <div className="bg-container">
                    <img src={logoImage} alt="Logo"/>
                    <br/>
                    <a href="http://kardiak.co.za" target="_blank"><img className='credit-image' src={creditImage} alt="Credit"/></a>
                    <br/>
                    <a href="https://apps.apple.com/za/app/plasees/id1598749583" target="_blank"><img className='badge-image' src={appStoreBadge} alt="App Store Badge"/></a>
                   {/* <h1>Awesome Title</h1>
                    <h2>Placeholder for home page header</h2>   
                    <Link to="/">Download</Link> */}
                </div>
            </header>
        </React.Fragment>
    )
}

export default Header;